export default {
  getLanguages: (state) => state.options
};
